import React from "react";
import { SectionTitle } from "./_components/SectionTitle";
import { CustomAccordion } from "./_components/CustomAccordion";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";
import { Backpack, DollarSign, Heart, MapPin } from "lucide-react";
import MainButton from "../../components/MainButton";
import { Separator } from "src/components/ui/separator";
import { Card } from "../../components/ui/card";
import { motion } from "framer-motion";

export default function MainFindJob() {
  return (
    <div className="space-y-20 max-w-7xl mx-auto px-4 mt-14">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">الصفحة الرئيسية</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>

          <BreadcrumbSeparator />

          <BreadcrumbItem>
            <BreadcrumbPage className="font-semibold">
              بحث عن وظيفة
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      {/* Filter */}
      <div className="border rounded-2xl grid grid-cols-1 md:grid-cols-4 gap-y-4 overflow-hidden">
        <div className="flex items-center gap-2 p-2">
          <DollarSign className="size-5" />
          <Select>
            <SelectTrigger
              className="flex-1 border-none focus:ring-0 p-0 shadow-none"
              dir={"rtl"}
            >
              <span className="text-sm text-muted-foreground">
                <SelectValue placeholder="المرتب" />
              </span>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={0}>$1000</SelectItem>
            </SelectContent>
          </Select>

          <Separator orientation="vertical" className="ms-5 hidden md:block" />
        </div>

        <div className="flex items-center gap-2 p-2">
          <Backpack className="size-5" />
          <Select>
            <SelectTrigger
              className="flex-1 border-none focus:ring-0 p-0 shadow-none"
              dir={"rtl"}
            >
              <span className="text-sm text-muted-foreground">
                <SelectValue placeholder="الدوام" />
              </span>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={0}>دوام كامل</SelectItem>
            </SelectContent>
          </Select>

          <Separator orientation="vertical" className="ms-5 hidden md:block" />
        </div>

        <div className="flex items-center gap-2 p-2 lg:pe-6">
          <MapPin className="size-5" />
          <Select>
            <SelectTrigger
              className="flex-1 border-none focus:ring-0 p-0 shadow-none"
              dir={"rtl"}
            >
              <span className="text-sm text-muted-foreground">
                <SelectValue placeholder="مكان العمل" />
              </span>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value={0}>عن بعد</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <MainButton
          title={"بحث عن وظائف"}
          className={"w-full md:h-full rounded-none h-12"}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {[1, 2, 3, 4].map((_, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
          >
            <JobCard />
          </motion.div>
        ))}
      </div>
    </div>
  );
}

const JobCard = () => {
  return (
    <Card className="p-6 space-y-6">
      <div className="flex items-center justify-between gap-4">
        <p className="font-bold text-sm">علي أكاديمي</p>
        <p className="text-sm text-muted-foreground">10 أيام</p>
      </div>
      <SectionTitle title={"مصمم مواقع أمامية"} className={"text-start"} />

      <div className="flex items-center gap-4 justify-between text-muted-foreground flex-wrap">
        <div className="flex items-center gap-1 text-sm">
          <DollarSign className="size-5" /> 15,000 : 20,000 ج.م
        </div>

        <div className="flex items-center gap-1 text-sm">
          <Backpack className="size-5" /> دوام كامل
        </div>

        <div className="flex items-center gap-1 text-sm">
          <MapPin className="size-5" /> عن بعد
        </div>
      </div>

      <div className="text-sm text-muted-foreground">
        نبحث عن مطور/ة واجهات أمامية موهوب/ة يتمتع بفهم عميق لتجربة المستخدم
        وتصميم الواجهات، للعمل على تطوير وتحسين المنصة التعليمية الرقمية. ستكون
        جزءًا من فريق تقني يسعى لتقديم تجربة تعلم رقمية سلسة، جذابة، وسهلة
        الاستخدام.
      </div>

      <div className="flex items-center gap-4 flex-wrap justify-between">
        <MainButton title={"تقدم الي الوظيفة"} />

        <Heart className="fill-red-500 stroke-none" />
      </div>
    </Card>
  );
};
